import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { Section } from "../../Common/layout/Section";
import { SubscriptionManagement } from "./Subscriptions";

export default function SubscriptionManagementPages() {
  return (
    <>
      <AsideMenu>
        <UserGroupMenu destination="/subscriptions" />
      </AsideMenu>
      <Section>
        <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>
            <ContentRoute path="/subscriptions/:userGroup" component={SubscriptionManagement} />
          </Switch>
        </Suspense>
      </Section>
    </>
  );
}
